import { createAction } from '@reduxjs/toolkit';
import { EventType, TaskType, ConditionScore } from '@Types/rehab.types';

export const fetchFieldMetadataAction = createAction<{
	type: 'events' | 'tasks' | 'condition';
	systemType: string;
	assetType: string;
	inspectionStandard: string;
}>('rehab/fieldMetadata/fetch');

export const fetchFieldMetadataResolved = createAction<{
	type: 'events' | 'tasks' | 'condition';
	data: EventType[] | TaskType[] | ConditionScore[];
}>('rehab/fieldMetadata/resolved');

export const fetchFieldMetadataRejected = createAction<{
	type: 'events' | 'tasks' | 'condition';
	error: string;
}>('rehab/fieldMetadata/rejected');

export const clearFieldMetadataAction = createAction('rehab/fieldMetadata/clear');
